<template>
  <div
    id="filter-registration-modal"
    class="modal fade filter-registration-modal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-borderless">
        <div class="modal-header">
          <h4 class="modal-title"></h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.stop.prevent="hideModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">{{ $t('form.local') }}</label>
                <select
                  class="form-control p-0 pl-2"
                  v-model="traineeLang"
                  id="locale"
                >
                  <option value="">{{ $t('allLanguages') }}</option>
                  <option value="FR">FR</option>
                  <option value="EN">EN</option>
                  <option value="NL">NL</option>
                  <option value="ES">ES</option>
                  <option value="IT">IT</option>
                  <option value="DK">DK</option>
                  <option value="SE">SE</option>
                  <option value="DE">DE</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">TRAINING </label>
                <treeselect
                  v-model="training"
                  :multiple="false"
                  :options="optionsTraining"
                  placeholder="TRAINING"
                  :normalizer="normalizer"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal"
                  >{{ $t('startDate') }} / {{ $t('endDate') }}
                </label>
                <date-picker
                  v-model="dateRange"
                  :lang="locale"
                  :format="$t('dateFormat')"
                  value-type="YYYY-MM-DD"
                  name="date"
                  class="form-control form-control_date"
                  id="dlv-dates"
                  range
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">{{ $t('form.status') }} </label>
                <treeselect
                  v-model="status"
                  :multiple="false"
                  :options="optionsStatus"
                  placeholder="Status"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex flex-wrap">
          <button
            @click.prevent.stop="filter"
            class="btn btn-primary"
            :disabled="invalid"
          >
            Filter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { lazyInput } from 'vue-lazy-input'
import { mapFields } from 'vuex-map-fields'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'FilterModal',
  directives: {
    lazyInput,
  },
  components: { DatePicker, Treeselect },
  data() {
    return {
      trainings: [],
      training: null,
      normalizer(node) {
        return {
          id: node,
          label: node,
        }
      },

      isLoaded: false,
      traineeLang: '',
      locale: '',
      showAlert: false,
      isSaving: false,
      dateRange: null,
      service: null,
      status: null,
      invalid: false,
      options: [
        { id: 1, label: 'Service 1' },
        { id: 2, label: 'Service 2' },
      ],
      training: null,
      optionsTraining: [],
      optionsStatus: [
        { id: 0, label: this.$t('notStartedStatus') },
        { id: 1, label: this.$t('inProgressStatus') },
        { id: 2, label: this.$t('failedStatus') },
        { id: 3, label: this.$t('SucceededStatus') },
      ],
      services: null,
      alert: {
        on: false,
        type: '',
        text: '',
      },
    }
  },
  computed: {
    ...mapFields(['user']),
  },

  mounted() {
    this.isLoaded = true
    this.locale = document.head.querySelector('meta[name="app-locale"]').content
    this.$bus.$on('filter-registration-modal.show', () => {
      $('#filter-registration-modal').modal('show')
    })
    this.$bus.$on('hide-filter-registration-modal', () => {
      $('#filter-registration-modal').modal('hide')
    })
    this.$store.dispatch('registrations/getTrainings').then((resp) => {
      this.optionsTraining = resp
    })
  },
  methods: {
    hideModal() {
      $('#filter-registration-modal.show').modal('hide')
      this.$refs.observer.reset()
    },
    filter() {
      let data = {
        startDate:
          this.dateRange && this.dateRange.length ? this.dateRange[0] : '',
        endDate:
          this.dateRange && this.dateRange.length ? this.dateRange[1] : '',
        languge: this.traineeLang,
        training: this.training,
        status: this.status,
        page: 1,
        limit: 50,
      }
      this.$bus.$emit('registration-filter', data)
    },
  },
}
</script>

<style></style>
